export function changeActiveTab(index) {
  return {
    type: "CHANGE_ACTIVE_TAB",
    payload: index
  }
}
